import { FlexCol, FlexRow } from "src/utils/flexLayouts";

export function LayoutWithAsideAndContent({ aside, content }: { aside: JSX.Element; content: JSX.Element }) {
  return (
    <FlexRow className="scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] h-screen overflow-y-auto">
      <FlexCol className="bg-white sticky-custom border-r w-80 text-[14px] text-[#8899A8] font-medium relative scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] max-h-screen">
        {aside}
      </FlexCol>
      <FlexCol className="grow w-[calc(100%-320px)]">{content}</FlexCol>
    </FlexRow>
  );
}
